import React from 'react'
import { useSelector } from 'react-redux'

export default function BookmarksItemsList({ className='', children }) {
    const listCoverRight = useSelector(state=>state.config.raindrops_list_cover_right)

    return (
        <div className={`${'ui-bm-view-list'} ${listCoverRight && 'list-cover-right'} ${className}`}>
            {children}
        </div>
    )
}